module.exports = __webpack_public_path__ + "img/symbol_s11.84041b5.svg";